import { type Session } from 'next-auth';

export const getAccountApiHeaders = (session?: null | Session) => {
  return {
    ...(session !== null && { Authorization: `Bearer ${session?.accessToken}` }),
    'Ocp-Apim-Subscription-Key': process.env.OCP_ACCOUNT_API_SUBSCRIPTION_KEY ?? '',
  };
};

export const getApiHeaders = (session?: null | Session) => {
  return {
    ...(session !== null && { Authorization: `Bearer ${session?.accessToken}` }),
    'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_OCP_API_SUBSCRIPTION_KEY ?? '',
  };
};

export const getNotificationsApiHeaders = (accessToken: string | undefined) => {
  return {
    ...(accessToken !== undefined && { Authorization: `Bearer ${accessToken}` }),
    'Ocp-Apim-Subscription-Key':
      (process.env.OCP_NOTIFICATIONS_API_SUBSCRIPTION_KEY ||
        window.PUBLIC_ENV.ocpNotificationsApiSubscriptionKey) ??
      '',
  };
};

export const postPushNotificationsApiHeaders = (accessToken: string | undefined) => {
  return {
    ...(accessToken !== undefined && { Authorization: `Bearer ${accessToken}` }),
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key':
      (process.env.OCP_NOTIFICATIONS_API_SUBSCRIPTION_KEY ||
        window.PUBLIC_ENV.ocpNotificationsApiSubscriptionKey) ??
      '',
  };
};
